import { Link, useSearchParams } from 'react-router-dom'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

/**
 * Stripe Checkout success landing page.
 *
 * Stripe redirects here after a completed subscription checkout, with
 * ?session_id={CHECKOUT_SESSION_ID} appended (configured via STRIPE_SUCCESS_URL).
 * The plan_tier change is applied server-side by the checkout.session.completed
 * webhook — this page only confirms and points onward; it does not grant access.
 */
export default function Success() {
    const [params] = useSearchParams()
    const sessionId = params.get('session_id')

    return (
        <div className="min-h-screen flex flex-col" style={{ backgroundColor: '#FAFAFA' }}>
            <Navbar />

            <div className="flex-1 w-full px-4 sm:px-6 py-16 sm:py-24 flex items-center justify-center">
                <div className="w-full max-w-md">
                    <div className="bg-white rounded-xl text-center px-8 sm:px-10 py-10"
                        style={{ border: '1px solid rgba(209,213,219,0.6)', boxShadow: '0 1px 3px rgba(0,0,0,0.04)' }}>

                        {/* Emerald check — matches the "Enforced / verified" status colour used across GMC */}
                        <div className="mx-auto mb-7 flex h-14 w-14 items-center justify-center rounded-full"
                            style={{ backgroundColor: 'rgba(16,185,129,0.08)', border: '1px solid rgba(16,185,129,0.2)' }}>
                            <svg width="26" height="26" viewBox="0 0 24 24" fill="none"
                                stroke="#059669" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                <path d="M5 13l4 4L19 7" />
                            </svg>
                        </div>

                        <p className="text-[10px] font-mono font-bold tracking-[0.28em] uppercase text-emerald-600 mb-4">
                            Payment confirmed
                        </p>

                        <h1 className="font-sans font-bold text-3xl text-gray-950 tracking-tight mb-3 leading-tight">
                            You&rsquo;re all set
                        </h1>

                        <p className="text-base font-body text-gray-600 leading-relaxed mb-8">
                            Your subscription is active and your analysis allowance is ready to use.
                        </p>

                        <div className="flex flex-col gap-3">
                            <Link to="/dashboard" className="btn-primary block text-center">
                                Go to your dashboard
                            </Link>
                            <Link to="/analyze"
                                className="block text-center rounded px-6 py-3 font-body font-semibold text-gray-600 border border-gray-300 transition-colors duration-200 hover:border-brand-amber hover:text-brand-amber">
                                Start an analysis
                            </Link>
                        </div>
                    </div>

                    {sessionId && (
                        <p className="mt-6 text-center text-[11px] font-mono text-gray-400">
                            Reference&nbsp;{sessionId.slice(0, 24)}&hellip;
                        </p>
                    )}
                </div>
            </div>

            <Footer />
        </div>
    )
}